(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["havn-product-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('[data-hvn-hero]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';

    const slides=[...root.querySelectorAll('[data-hvn-slide]')];
    const thumbs=[...root.querySelectorAll('[data-hvn-thumb]')];
    let idx=0;

    const show=i=>{
      if(!slides.length)return;
      idx=(i+slides.length)%slides.length;
      slides.forEach((s,n)=>{s.hidden=n!==idx;s.classList.toggle('is-active',n===idx)});
      thumbs.forEach((t,n)=>t.classList.toggle('is-active',n===idx));
    };

    root.querySelector('[data-hvn-prev]')?.addEventListener('click',()=>show(idx-1));
    root.querySelector('[data-hvn-next]')?.addEventListener('click',()=>show(idx+1));
    thumbs.forEach(t=>t.addEventListener('click',()=>show(Number(t.dataset.hvnThumb))));

    const variants=JSON.parse(root.querySelector('[data-hvn-variants]')?.textContent||'[]');
    const idInput=root.querySelector('[data-hvn-variant-id]');
    const atc=root.querySelector('[data-hvn-atc]');
    const atcText=root.querySelector('[data-hvn-atc-text]');

    const refreshVariant=()=>{
      const fields=[...root.querySelectorAll('[data-hvn-option]')];
      if(!fields.length)return;
      const selected=fields.map(f=>f.querySelector('[data-hvn-option-input]:checked')?.value);
      const match=variants.find(v=>v.options.every((o,i)=>o===selected[i]));
      if(!match){if(atc)atc.disabled=true;if(atcText)atcText.textContent='Unavailable';return}
      if(idInput)idInput.value=match.id;
      if(atc)atc.disabled=!match.available;
      if(atcText)atcText.textContent=match.available?'{{ section.settings.atc_text | escape }}':'Sold out';
    };

    root.querySelectorAll('[data-hvn-option-input]').forEach(i=>i.addEventListener('change',refreshVariant));

    root.querySelectorAll('[data-hvn-bundle]').forEach(btn=>btn.addEventListener('click',()=>{
      root.querySelectorAll('[data-hvn-bundle]').forEach(x=>x.classList.remove('is-selected'));
      btn.classList.add('is-selected');
      const vid=btn.dataset.variantId;
      if(vid && /^\d+$/.test(vid) && idInput) idInput.value=vid;
    }));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["infinity-compare"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-inf-compare]').forEach(root=>{
  root.querySelectorAll('[data-tab]').forEach(btn=>{
    btn.addEventListener('click',()=>{
      root.querySelectorAll('[data-tab]').forEach(x=>x.classList.toggle('is-active',x===btn));
      root.querySelectorAll('[data-panel]').forEach(p=>p.classList.toggle('is-hidden',p.dataset.panel!==btn.dataset.tab));
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["infinity-product-offer"] && !Shopify.designMode) return;
  try {
    

(() => {

  document
    .querySelectorAll('[data-inf-offer]')
    .forEach(root => {

      if (root.dataset.ready) return;

      root.dataset.ready = '1';


      const slides =
        [...root.querySelectorAll('[data-slide]')];

      const dots =
        [...root.querySelectorAll('[data-dot]')];

      let idx = 0;


      const show = i => {

        if (!slides.length) return;

        idx =
          (i + slides.length)
          % slides.length;


        slides.forEach(
          (slide, n) => {

            slide.hidden =
              n !== idx;

            slide.classList.toggle(
              'is-active',
              n === idx
            );

          }
        );


        dots.forEach(
          (dot, n) => {

            dot.classList.toggle(
              'is-active',
              n === idx
            );

          }
        );

      };


      root
        .querySelector('[data-prev]')
        ?.addEventListener(
          'click',
          () => show(idx - 1)
        );


      root
        .querySelector('[data-next]')
        ?.addEventListener(
          'click',
          () => show(idx + 1)
        );


      dots.forEach(
        dot => {

          dot.addEventListener(
            'click',
            () =>
              show(
                Number(dot.dataset.dot)
              )
          );

        }
      );


      const variants =
        JSON.parse(
          root
            .querySelector('[data-variants]')
            ?.textContent
          || '[]'
        );


      const idInput =
        root.querySelector(
          '[data-variant-id]'
        );


      const atc =
        root.querySelector(
          '[data-atc]'
        );


      const atcText =
        root.querySelector(
          '[data-atc-text]'
        );


      const refreshVariant = () => {

        const optionFields =
          [
            ...root.querySelectorAll(
              '.inf-offer__option'
            )
          ];


        if (!optionFields.length) {
          return;
        }


        const selected =
          optionFields.map(
            fieldset =>
              fieldset
                .querySelector(
                  '[data-option-input]:checked'
                )
                ?.value
          );


        const match =
          variants.find(
            variant =>
              variant.options.every(
                (option, index) =>
                  option === selected[index]
              )
          );


        if (!match) {

          if (atc) {
            atc.disabled = true;
          }

          if (atcText) {
            atcText.textContent =
              'Unavailable';
          }

          return;
        }


        if (idInput) {
          idInput.value =
            match.id;
        }


        if (atc) {
          atc.disabled =
            !match.available;
        }


        if (atcText) {

          atcText.textContent =
            match.available
              ? '{{ section.settings.atc_label | escape }}'
              : 'Sold out';

        }


        const url =
          new URL(
            window.location.href
          );


        url.searchParams.set(
          'variant',
          match.id
        );


        window.history.replaceState(
          {},
          '',
          url
        );

      };


      root
        .querySelectorAll(
          '[data-option-input]'
        )
        .forEach(
          input => {

            input.addEventListener(
              'change',
              refreshVariant
            );

          }
        );


      root
        .querySelectorAll(
          '[data-plan]'
        )
        .forEach(
          plan => {

            plan.addEventListener(
              'click',
              () => {

                root
                  .querySelectorAll(
                    '[data-plan]'
                  )
                  .forEach(
                    other =>
                      other
                        .classList
                        .remove(
                          'is-selected'
                        )
                  );


                plan
                  .classList
                  .add(
                    'is-selected'
                  );

              }
            );

          }
        );

    });

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["relief-product-offer"] && !Shopify.designMode) return;
  try {
    
(()=>{
  document.querySelectorAll('[data-r-offer]').forEach(root=>{
    if(root.dataset.rBundleReady==='1') return;
    root.dataset.rBundleReady='1';

    const slides=[...root.querySelectorAll('[data-r-slide]')];
    const thumbs=[...root.querySelectorAll('[data-r-thumb]')];
    let idx=0;

    const show=i=>{
      if(!slides.length)return;
      idx=(i+slides.length)%slides.length;
      slides.forEach((s,n)=>s.hidden=n!==idx);
      thumbs.forEach((t,n)=>t.classList.toggle('active',n===idx));
    };

    root.querySelector('[data-r-prev]')?.addEventListener('click',()=>show(idx-1));
    root.querySelector('[data-r-next]')?.addEventListener('click',()=>show(idx+1));
    thumbs.forEach(t=>t.addEventListener('click',()=>show(Number(t.dataset.rThumb))));

    const plans=[...root.querySelectorAll('[data-r-plan]')];
    const includedPanels=[...root.querySelectorAll('[data-r-included]')];
    const atc=root.querySelector('[data-r-atc]');
    const atcText=root.querySelector('[data-r-atc-text]');
    const hiddenId=root.querySelector('[data-r-variant-id]');

    const isValidId=value => !!value && /^\d+$/.test(String(value)) && String(value)!=='0';

    let selectedPlan =
      plans.find(p=>p.classList.contains('selected') && !p.disabled) ||
      plans.find(p=>!p.disabled) ||
      null;

    const selectPlan=plan=>{
      if(!plan || plan.disabled)return;

      selectedPlan=plan;

      plans.forEach(p=>{
        p.classList.toggle('selected',p===plan);
        p.setAttribute('aria-pressed',p===plan ? 'true' : 'false');
      });

      includedPanels.forEach(panel=>{
        const active=panel.dataset.includedFor===plan.dataset.blockId;
        panel.classList.toggle('is-hidden',!active);
      });

      const variantId=plan.dataset.variantId;

      if(hiddenId && isValidId(variantId)){
        hiddenId.value=variantId;
        hiddenId.setAttribute('value',variantId);
      }
    };

    plans.forEach(plan=>{
      plan.addEventListener('click',event=>{
        event.preventDefault();
        selectPlan(plan);
      });
    });

    if(selectedPlan) selectPlan(selectedPlan);

    atc?.addEventListener('click',async event=>{
      event.preventDefault();
      event.stopPropagation();

      if(!selectedPlan || selectedPlan.disabled){
        alert('Please select an available offer.');
        return;
      }

      const variantId=selectedPlan.dataset.variantId;

      if(!isValidId(variantId)){
        alert('This offer is missing its Shopify variant ID.');
        return;
      }

      const originalText=atcText?.textContent || 'ADD TO CART';

      atc.disabled=true;
      atc.setAttribute('aria-busy','true');
      if(atcText) atcText.textContent='ADDING...';

      try{
        const response=await fetch(window.Shopify?.routes?.root
          ? window.Shopify.routes.root + 'cart/add.js'
          : '/cart/add.js',{
          method:'POST',
          headers:{
            'Content-Type':'application/json',
            'Accept':'application/json'
          },
          body:JSON.stringify({
            items:[{
              id:Number(variantId),
              quantity:1
            }]
          })
        });

        const payload=await response.json().catch(()=>({}));

        if(!response.ok){
          throw new Error(payload.description || payload.message || 'Unable to add this offer to cart.');
        }

        window.location.href=window.Shopify?.routes?.root
          ? window.Shopify.routes.root + 'cart'
          : '/cart';
      }catch(error){
        console.error('[Relief offer cart error]',error);
        if(atcText) atcText.textContent=originalText;
        atc.disabled=false;
        atc.removeAttribute('aria-busy');
        alert(error.message || 'Unable to add this offer to cart.');
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
